const parameterList = [
    {value: "actualEnginePercentTorque", label: "Aktüel Motor Tork Yüzdesi"},
    {value: "engineSpeed", label: "Motor Hızı"},
    {value: "vehicleSpeed", label: "Araç Hızı"},
    {value: "fuelRate", label: "Anlık Yakıt Tüketimi"},
    {value: "instantaneousFuelEconomy", label: "Mevcut Araç Hızında Mevcut Yakıt Ekonomisi"},
    {value: "actualRetarderPercentTorque", label: "Aktüel Retarder Tork Yüzdesi"},
    {value: "wheelBasedSpeed", label: "Tekerlek Bazlı Hız"},
    {value: "acceleratorPedalPosition", label: "Gaz Pedalı Pozisyonu (%)"}, // %100
    {value: "currentGear", label: "Vites"}, // 1-6
    {value: "bellowPressFrontAxleLeft", label: "Körük Basıncı Ön Aks Sol"},
    {value: "bellowPressFrontAxleRight", label: "Körük Basıncı Ön Aks Sağ"},
    {value: "bellowPressRearAxleLeft", label: "Körük Basıncı Arka Aks Sol"},
    {value: "bellowPressRearAxleRight", label: "Körük Basıncı Arka Aks Sağ"},
    {value: "brakePedalPosition", label: "Fren Pedal Yüzdesi"},
    {value: "steeringWheelAngle", label: "Direksiyon Açısı"},
    {value: "fuelLevel", label: "Yakıt Seviyesi"},
    {value: "engineTotalHoursOfOperation", label: "Toplam Motor Çalışma Süresi"},
    {value: "highResVehicleTotalDistance", label: "Toplam Araç Mesafesi"},
    {value: "engineCoolantTemp", label: "Motor Soğutma Suyu Sıcaklığı"},
    {value: "ambientAirTemp", label: "Ortam Hava Sıcaklığı"},
    {value: "serviceBrakeAirPressureCircuit1", label: "Servis Freni Hava Basıncı Devresi 1"},
    {value: "serviceBrakeAirPressureCircuit2", label: "Servis Freni Hava Basıncı Devresi 2"},
    {value: "LiquetEngineTotalFuelUsed", label: "Yüksek Çözünürlüklü Toplam Yakıt Tüketimi"},
    {value: "AftertreatmentDieselExhaustFluidTank1Level", label: "AdBlue Seviyesi"},
    {value: "GaseousTotalFuelUsed", label: "Toplam Gazlı Yakıt Tüketimi"},
    {value: "hybridBatteryPackRemainingCharge", label: "Hibrit Pil Paketinin Kalan Şarj Yüzdesi"},
    {value: "TT_ID0_tts1", label: "Klima"},
    {value: "TT_ID0_tts2", label: "Uzun Far"},
    {value: "TT_ID0_tts3", label: "Kısa Far"},
    {value: "TT_ID0_tts4", label: "Dönüş Sinyalleri"},
    {value: "TT_ID0_tts5", label: "Tehlike Uyarısı"},
    {value: "TT_ID0_tts6", label: "Engelliler İçin Anlam"},
    {value: "TT_ID0_tts7", label: "El Freni"},
    {value: "TT_ID0_tts8", label: "Fren Arızası"},
    {value: "TT_ID0_tts9", label: "Tavan Kapağı"},
    {value: "TT_ID0_tts10", label: "Yakıt Seviyesi"},
    {value: "TT_ID0_tts11", label: "Motor Suyu Soğutma"},
    {value: "TT_ID0_tts12", label: "Akıllı Şarj Durumu"},
    {value: "TT_ID0_tts13", label: "Motor Yağı"},
    {value: "TT_ID0_tts14", label: "Pozisyon Lambaları"},
    {value: "TT_ID0_tts15", label: "Ön Sis Lambaları"},
    {value: "TT_ID1_tts1", label: "Arka Sis Lambaları"},
    {value: "TT_ID1_tts2", label: "Park Isıtma"},
    {value: "TT_ID1_tts3", label: "Motor / MI Göstergesi"},
    {value: "TT_ID1_tts4", label: "Servis & Bakım"},
    {value: "TT_ID1_tts5", label: "Şanzıman Sıvısı"},
    {value: "TT_ID1_tts6", label: "Şanzıman Hatası"},
    {value: "TT_ID1_tts7", label: "ABS Arızası"},
    {value: "TT_ID1_tts8", label: "Aşınmış Fren Arızası"},
    {value: "TT_ID1_tts9", label: "Ön Cam Yıkama Sıvısı"},
    {value: "TT_ID1_tts10", label: "Lastik Arızası"},
    {value: "TT_ID1_tts11", label: "Arıza / Genel Arıza"},
    {value: "TT_ID1_tts12", label: "Motor Yağı Sıcaklık Göstergesi"},
    {value: "TT_ID1_tts13", label: "Motor Yağı Seviyesi"},
    {value: "TT_ID1_tts14", label: "Motor Soğutma Suyu"},
    {value: "TT_ID1_tts15", label: "Direksiyon Sıvısı Seviyesi"},
    {value: "TT_ID2_tts1", label: "Direksiyon Arızası"},
    {value: "TT_ID2_tts2", label: "Yükseklik Kontrolü"},
    {value: "TT_ID2_tts3", label: "Retarder"},
    {value: "TT_ID2_tts4", label: "Motor Emisyon Sistemi"},
    {value: "TT_ID2_tts5", label: "ESC Göstergesi"},
    {value: "TT_ID2_tts6", label: "Fren Lambası"},
    {value: "TT_ID2_tts7", label: "Körüklü Araç"},
    {value: "TT_ID2_tts8", label: "Durma Talebi"},
    {value: "TT_ID2_tts9", label: "Çocuk Arabası İsteği"},
    {value: "TT_ID2_tts10", label: "Otobüs Durağı Freni"},
    {value: "TT_ID2_tts11", label: "AdBlue Seviyesi"},
    {value: "TT_ID2_tts12", label: "Yükseltme"},
    {value: "TT_ID2_tts13", label: "İndirme"},
    {value: "TT_ID2_tts14", label: "Düşürme"},
    {value: "TT_ID2_tts15", label: "Motor Bloğu Sıcaklığı"},
    {value: "TT_ID3_tts1", label: "Yardımcı Hava Basıncı"},
    {value: "TT_ID3_tts2", label: "Hava Filtresi"},
    {value: "TT_ID3_tts3", label: "Yakıt Filtresi Fark Basıncı"},
    {value: "TT_ID3_tts4", label: "Emniyet Kemeri"},
    {value: "TT_ID3_tts5", label: "EBS"},
    {value: "TT_ID3_tts6", label: "Şeritten Ayrılma Göstergesi"},
    {value: "TT_ID3_tts7", label: "Gelişmiş Acil Durum Fren sistemi"},
    {value: "TT_ID3_tts8", label: "ACC"},
    {value: "TT_ID3_tts9", label: "Römork Bağlandı"},
    {value: "TT_ID3_tts10", label: "ABS Trailer 1,2"},
    {value: "TT_ID3_tts11", label: "Airbag"},
    {value: "TT_ID3_tts12", label: "EBS Trailer 1,2"},
    {value: "TT_ID3_tts13", label: "Takograf Göstergesi"},
    {value: "TT_ID3_tts14", label: "ESC Göstergesi Kapalı"},
    {value: "TT_ID3_tts15", label: "Şeritten Ayrılma Göstergesi Kapalı"},
    {value: "TT_ID4_tts1", label: "Motor Emisyon Filtresi"},
    {value: "TT_ID4_tts2", label: "Elektrik Motoru Arızaları"},
    {value: "TT_ID4_tts3", label: "Adblue Sıcaklığı"},
    {value: "TT_ID4_tts4", label: "Multiplex Sistem"},
    {value: "TT_ID4_tts5", label: "FMS Standardı için ayrılmıştır"}
];

export default parameterList;
